const ConfirmationModal = getModule('IO.Views.ConfirmationModal');

class WarnHierarchyLevel {
  constructor(form, hierarchyField) {
    this.form = form;
    this.hierarchyField = hierarchyField;
    this.warn();
  }

  proceed(shouldProceed) {
    if (shouldProceed) {
      $(this.form).addClass('hierarchy-impact-yes');
      $(this.form).submit();
    } else {
      $(this.form).addClass('hierarchy-impact-no');
    }
  }

  warn() {
    $.ajax({
      url: '/' + currentCustomer + '/stores/check_hierarchy_management',
      data: { hierarchy_field_id: this.hierarchyField }, // eslint-disable-line camelcase
    }).done((data) => {
      if (data.expected_level_name.length === 0) {
        this.proceed(true);
      } else {
        this.showModal(data.expected_level_name);
      }
    });
  }

  showModal(hierarchyDefinition) {
    var msg, confirmationModal;

    msg =
      'This store will no longer be managed by Hierarchy Template Management. Do you';
    msg +=
      '<br>' +
      'want to proceed? Otherwise, please select a field in ' +
      hierarchyDefinition;
    msg += ' or lower.';

    confirmationModal = new ConfirmationModal({
      el: '#confirmation-modal',
      closeable: false,
    });

    confirmationModal.show(msg, this.proceed.bind(this));
  }
}

module.exports = WarnHierarchyLevel;
